/**
 * TanStack Query hooks for `igaming-admin-fees-deduction-from-ngr`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingAdminFeesDeductionFromNgrQueryKeys,
	type CreateIgamingAdminFeesDeductionFromNgrBody,
	type ListIgamingAdminFeesDeductionFromNgrResponse,
	type IgamingAdminFeesDeductionFromNgrRow,
} from "./api";

export function useIgamingAdminFeesDeductionFromNgrList(): UseQueryResult<ListIgamingAdminFeesDeductionFromNgrResponse, Error> {
	return useQuery({
		queryKey: igamingAdminFeesDeductionFromNgrQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingAdminFeesDeductionFromNgrCreate(): UseMutationResult<IgamingAdminFeesDeductionFromNgrRow, Error, CreateIgamingAdminFeesDeductionFromNgrBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingAdminFeesDeductionFromNgrQueryKeys.all });
		},
	});
}

export function useIgamingAdminFeesDeductionFromNgrDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingAdminFeesDeductionFromNgrQueryKeys.all });
		},
	});
}
